import { AlertWarning } from "../component/basic/feedbacks/snackbar/Snackbar";
import { EmptyRsp } from "../model/APIData";
import { BookReport, OpenReportByBookRsp, TODOMark } from "../model/Report";
import { LogDebug } from "../tools/log";
import { requestBackend } from "./common";

interface OpenReportByBookProps {
    templateID: string;
    afterSuccess: (report: BookReport) => void;
    dispatch: any;
}

export function OpenReportByBook(props: OpenReportByBookProps) {
    const { templateID, afterSuccess, dispatch } = props;
    const req_data = {
        temp_id: templateID,
    };
    requestBackend({
        uri: `/api/report/open_by_book`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new OpenReportByBookRsp();
            Object.assign(rsp, rsp_json);
            LogDebug("OpenReportByBookRsp", rsp);
            if (rsp.hint.length > 0) {
                AlertWarning(rsp.hint);
            } else {
                afterSuccess(rsp.book_report);
            }
            return rsp;
        },
        errTitle: "开启练习册失败",
        dispatch,
        backdrop: true,
    });
}

interface RemakeReportProps {
    id: string;
    afterSuccess: () => void;
    dispatch: any;
}

export function RemakeReport(props: RemakeReportProps) {
    const { id, afterSuccess, dispatch } = props;
    const req_data = {
        temp_id: id,
    };
    requestBackend({
        uri: `/api/report/remake`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new EmptyRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess();
            return rsp;
        },
        errTitle: "操作失败",
        dispatch,
        backdrop: true,
    });
}

interface UpdateTOODMarkProps {
    templateID: string;
    mark: TODOMark;
    afterSuccess: () => void;
    dispatch: any;
}
export function UpdateTOODMark(props: UpdateTOODMarkProps) {
    const { templateID, afterSuccess, dispatch, mark } = props;
    const req_data = {
        temp_id: templateID,
        mark: mark,
    };
    requestBackend({
        uri: `/api/report/update_todo_mark`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new EmptyRsp();
            Object.assign(rsp, rsp_json);
            LogDebug("EmptyRsp", rsp);
            afterSuccess();
            return rsp;
        },
        errTitle: "更新笔记失败",
        dispatch,
        backdrop: true,
    });
}
